import { successColor } from 'assets/jss/material-dashboard-pro-react';
const textWithIconStyle = (theme) => ({
	packageWrapper: {
		'margin-top': '24px',
		display: 'inline-grid',
		'column-gap': '5rem',
		'row-gap': '1rem',
		'margin-bottom': '24px',
		[theme.breakpoints.down('sm')]: {
			display: 'inline-grid',
			'column-gap': '5rem',
			'row-gap': '1rem',
		},
	},
	packageDiv: {
		display: 'flex',
	},
	packageName: {
		margin: '.1rem 0 0 0.4rem',
		'font-size': 'medium',
	},
	circle: {
		color: successColor[0],
		width: '1rem',
	},
	displayInline: {
		display: 'grid !important',
		gridTemplateColumns: 'auto auto auto',
		[theme.breakpoints.down('sm')]: {
			gridTemplateColumns: 'auto !important',
		},
	}
});
export default textWithIconStyle;
